export default __webpack_public_path__ + "static/logo-blanc-b6827fb030e4e286103677cb560faa5a.png";